import Store from './Store';

const TemplateStore = new Store('templates');

export {TemplateStore};